"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = Tooltip;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _generic = _interopRequireDefault(require("../icons/generic"));
var _utils = require("../../utils/utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
// Packages

// Components

// Utils

// Styles
const {
  canHover
} = (0, _utils.getMediaQueries)();
const Container = _styledComponents.default.div.withConfig({
  displayName: "tooltip__Container",
  componentId: "sc-wdbp90-0"
})(["position:relative;button{align-items:center;background:transparent;border:none;border-radius:50%;cursor:pointer;display:flex;justify-content:center;padding:14px;transition:all 0.2s ease-in-out;&.active{background:transparent;svg{path{fill:", ";}}}", "}.tooltip{background:", ";bottom:", ";left:", ";padding:8px;position:absolute;right:", ";top:", ";.tooltip-content{*{color:", ";font-size:12px;line-height:16px;}}}"], props => props.tooltipIconActiveColor || _utils.colors["pacific-blue-1"].hex, canHover`
      :hover {
        background: ${props => props.showTooltip ? "transparent" : _utils.colors["ice-grey-1"].hex};
      }
    `, props => props.toolTipBackground, props => props.placementBottom && props.placementBottom, props => props.placementLeft && props.placementLeft, props => props.placementRight && props.placementRight, props => props.placementTop && props.placementTop, props => props.tooltipContentColor);
function Tooltip({
  tooltipContent,
  placementBottom,
  placementLeft,
  placementRight,
  placementTop,
  tooltipContentColor,
  toolTipBackground,
  tooltipIconActiveColor,
  tooltipIconTitle
}) {
  const {
    0: showTooltip,
    1: setShowTooltip
  } = (0, _react.useState)(false);
  return /*#__PURE__*/_react.default.createElement(Container, {
    showTooltip: showTooltip,
    toolTipBackground: toolTipBackground,
    placementBottom: placementBottom,
    placementLeft: placementLeft,
    placementRight: placementRight,
    placementTop: placementTop,
    tooltipContentColor: tooltipContentColor,
    tooltipIconActiveColor: tooltipIconActiveColor
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: () => setShowTooltip(!showTooltip),
    className: showTooltip ? "active" : ""
  }, /*#__PURE__*/_react.default.createElement(_generic.default, {
    icon: "help-circle",
    color: "#fff",
    title: tooltipIconTitle
  })), showTooltip && /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "tooltip-content"
  }, tooltipContent)));
}
Tooltip.propTypes = {
  /**
   * Content can be a string or an element (e.g. React component)
   */
  tooltipContent: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]).isRequired,
  /**
   * Absolute position bottom value (e.g. 10px)
   */
  placementBottom: _propTypes.default.string,
  /**
   * Absolute position left value (e.g. 10px)
   */
  placementLeft: _propTypes.default.string,
  /**
   * Absolute position right value (e.g. 10px)
   */
  placementRight: _propTypes.default.string,
  /**
   * Absolute position top value (e.g. 10px)
   */
  placementTop: _propTypes.default.string,
  /**
   * Color of content text
   */
  tooltipContentColor: _propTypes.default.string,
  /**
   * Background color of tooltip
   */
  toolTipBackground: _propTypes.default.string,
  /**
   * Active color of tooltip icon (question mark)
   */
  tooltipIconActiveColor: _propTypes.default.string,
  tooltipIconTitle: _propTypes.default.string
};
Tooltip.defaultProps = {
  toolTipBackground: _utils.colors["ice-grey-1"].hex,
  tooltipContentColor: "#000"
};
Tooltip.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Tooltip",
  "props": {
    "toolTipBackground": {
      "defaultValue": {
        "value": "colors[\"ice-grey-1\"].hex",
        "computed": true
      },
      "description": "Background color of tooltip",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "tooltipContentColor": {
      "defaultValue": {
        "value": "\"#000\"",
        "computed": false
      },
      "description": "Color of content text",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "tooltipContent": {
      "description": "Content can be a string or an element (e.g. React component)",
      "type": {
        "name": "union",
        "value": [{
          "name": "element"
        }, {
          "name": "string"
        }]
      },
      "required": true
    },
    "placementBottom": {
      "description": "Absolute position bottom value (e.g. 10px)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "placementLeft": {
      "description": "Absolute position left value (e.g. 10px)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "placementRight": {
      "description": "Absolute position right value (e.g. 10px)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "placementTop": {
      "description": "Absolute position top value (e.g. 10px)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "tooltipIconActiveColor": {
      "description": "Active color of tooltip icon (question mark)",
      "type": {
        "name": "string"
      },
      "required": false
    },
    "tooltipIconTitle": {
      "description": "",
      "type": {
        "name": "string"
      },
      "required": false
    }
  }
};